import HundredBricksAPIError from '../../HundredBricksAPIError';
class UploadRegimeProofError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('UploadRegimeProofError', ...args);
    }
}
export default UploadRegimeProofError;
